export default "__VITE_ASSET__CJqKXfKN__"